import store from './store';
import {i18n} from '@/fit-components/common/lang';
import {getDefaultConfig, DialogOptions} from "@/fit-components/dialog/business";
// @ts-ignore
function update(config: DialogOptions) {
    Object.keys(config).forEach((key) => {
        if (typeof store.dialog[key] !== 'undefined') {
            store.dialog[key] = config[key];
        }
    });
}

export function showDialog(options: DialogOptions) {
    const config = Object.assign(getDefaultConfig(), {
        show: true,
    }, options);
    update(config);
}

export function hideDialog() {
    const config = Object.assign(getDefaultConfig(), {
        show: false,
    });
    update(config);
}

export function showBusinessError(error?: any, options:DialogOptions = {}) {
    if (error && error.title) {
        showDialog(Object.assign({}, {
            title: error.title
        }, options));
        return;
    }
    if (error && error.retmsg) {
        showDialog(Object.assign({}, {
            title: error.retmsg
        }, options));
        return;
    }
    if (typeof error === 'string') {
        showDialog({
            title: error
        });
        return;
    }
    showDialog({
        title: i18n('系统繁忙')
    })
}

export function showSimpleDialog(content: string) {
    const config = Object.assign(getDefaultConfig(), {
        show: true,
    });
    config.content = content;
    console.log(config);
    update(config);
}


